
import CompaniesList from "../Pages/ServitorCompanies/CompaniesList";
import CompanyServices from "../Pages/ServitorCompanies/CompanyServices";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import Register from "../Pages/Auth/Register";
import Profile from "../Pages/Profile/Profile";
import Home from "../Pages/Home/Home";
import Splash from "../Pages/Splash";
import SetRequestOptions from "../Pages/Requests/SetRequestOptions";
import AddAddress from "../Pages/Profile/AddAddress";
import Requests from "../Pages/Requests/Requests";
import Content from "../Pages/Profile/Content";
import Request from "../Pages/Requests/Request";
import SearchServices from "../Pages/Home/SearchServices";
import Reagent from "../Pages/Auth/Reagent";
import InviteOthers from "../Pages/Profile/InviteOthers";
import EditProfile from "../Pages/Profile/EditProfile";
import Wallet from "../Pages/Profile/Wallet";
import NewAddress from "../Pages/Profile/NewAddress";
import RequestRate from "../Pages/Requests/RequestRate";


const appRoutes = [
    {
        pageId : 0,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 1,
        path: "/home",
        component: <Home />,
    },
    {
        pageId : 2,
        path: "/home/companies/:id",
        component: <CompaniesList />,
    },
    {
        pageId : 3,
        path: "/company/:id",
        component: <CompanyServices />,
    },
    {
        pageId : 4,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 5,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 6,
        path: "/register",
        component: <Register />,
    },
    {
        pageId : 7,
        path: "/profile",
        component: <Profile />,
    },
    {
        pageId : 8,
        path: "/request-options",
        component: <SetRequestOptions />,
    },
    {
        pageId : 9,
        path: "/add-address",
        component: <AddAddress />,
    },
    {
        pageId : 10,
        path: "/requests",
        component: <Requests />,
    },
    {
        pageId : 11,
        path: "/requests/:id",
        component: <Request />,
    },
    {
        pageId : 12,
        path: "/contents/:slug",
        component: <Content />,
    },
    {
        pageId : 13,
        path: "/search",
        component: <SearchServices />,
    },
    {
        pageId : 14,
        path: "/invite/:code",
        component: <Reagent />,
    },
    {
        pageId : 15,
        path: "/profile/invite-others",
        component: <InviteOthers />,
    },

    {
        pageId : 16,
        path: "/edit-profile",
        component: <EditProfile />,
    },
    {
        pageId : 17,
        path: "/wallet",
        component: <Wallet />,
    },
    {
        pageId : 18,
        path: "/new-address",
        component: <NewAddress />,
    },
    {
        pageId : 19,
        path: "/rate/:id",
        component: <RequestRate />,
    },
];
export default appRoutes;